'use client';

import PositionDetailPageMobile from "@/components/trader/positionDetail/PositionMobile";
import PositionDetailPagePC from "@/components/trader/positionDetail/PositionPC";

export default function PositionDetailPage() {
  // Logic for app download - detect platform and redirect to appropriate store
  const userAgent = navigator.userAgent;

  // Desktop - show both options or default to iOS App Store
  const isMobile =
    /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );

  return isMobile ? <PositionDetailPageMobile /> : <PositionDetailPagePC />;
}
